module.exports = __webpack_public_path__ + "img/促销.png";